import Vuex from 'vuex';
import users from './users';
import groups from './groups';
import tokens from './tokens';
import audit from './audit';
import permissions from './permissions';
import cloud from './cloud';
import enterprise from './enterprise';
import alert from './alert';
import auth from './auth';
import approvals from './approvals';
import zoho from './zoho';
import domainsapi from './domainsapi';
import messaging from './messaging';

/**
 * Construct the Vuex store
 *
 * @param {*} services Services object for API access
 * @return {Store} Constructed Vuex store
 */
export default function(services) {
  return new Vuex.Store({
    modules: {
      users: users(services),
      groups: groups(services),
      tokens,
      audit: audit(services),
      permissions: permissions(services),
      cloud: cloud(services),
      enterprise: enterprise(services),
      alert,
      auth,
      approvals: approvals(services),
      zoho: zoho(services),
      domainsapi: domainsapi(services),
      messaging: messaging(services)
    }
  });
}
